/**
 * i18n key for a scope's human label. Scope values contain a colon (`deliveries:import`), which
 * i18next reads as a namespace separator, so the key swaps it for an underscore.
 */
export function scopeLabelKey(scope: string): string {
  return `scopes.${scope.replace(/:/g, '_')}`
}

/** Tokens that still work — revoked ones stay listed for the audit trail. */
export function activeTokenCount(tokens: Array<{ active: boolean }>): number {
  return tokens.filter((token) => token.active).length
}
